import React from "react";
import {FaEdit, FaTrash} from "react-icons/fa";

function VoicesTable({voices, onEdit, onDelete}) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Friendly Name</th>
                <th>TTS Service Provider</th>
                <th>Language Locale</th>
                <th>Gender</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {voices.map(voice => (
                <VoiceRow voice={voice} key={voice.id} onEdit={onEdit} onDelete={onDelete}/>
            ))}
            </tbody>
        </table>
    );
}

function VoiceRow({voice, onEdit, onDelete}) {
    return (
        <tr>
            <td>{voice.id}</td>
            <td>{voice.name}</td>
            <td>{voice.friendlyName}</td>
            <td>{voice.ttsServiceProvider}</td>
            <td>{voice.languageLocale}</td>
            <td>{voice.gender}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(voice)}/>
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(voice.id)}/>
            </td>
        </tr>
    );
}

export default VoicesTable;
